import { useMemo } from 'react';
import { canUpdate } from 'utils/permissions';
import { PermissionActionsRetriever } from 'src/definitions/custom-models';
import { JobFamily } from './jobFamily.graphql';

interface Args {
  loading: boolean;
  editableResource?: JobFamily | null;
}

export const useDisabledJobFamilyFields = (args: Args) => {
  const { loading, editableResource } = args;

  return useMemo(() => {
    const shouldFieldsBeDisabled = (permissionRetriever: PermissionActionsRetriever): boolean =>
      loading || (Boolean(editableResource) && !canUpdate(permissionRetriever(editableResource?.permissions)));

    return shouldFieldsBeDisabled((permissions) => permissions?.JOB_FAMILY);
  }, [loading, editableResource]);
};
